import React from 'react';
import PayoutsContainer from "../containers/PayoutsContainer";

const PayoutsView = () => {

  return (
    <PayoutsContainer/>
  );
};

export default PayoutsView;
